import { gql } from '@apollo/client';

const GET_KEYBOARDING_MODULES_QUERY = gql`
  query getKeyboardingModules {
    keyboardingModules {
      id
      parentModuleId
      name
      description
    }
  }
`;

export default GET_KEYBOARDING_MODULES_QUERY;
